import { Component, OnInit } from '@angular/core';
import { SourceAuthoritesAfterAuthenticationService } from 'src/app/services/auth/source-authorites-after-authentication.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-gerer-mes-benefs',
  templateUrl: './gerer-mes-benefs.component.html',
  styleUrls: ['./gerer-mes-benefs.component.scss']
})
export class GererMesBenefsComponent implements OnInit {

  fileNamePattern = new RegExp(this.configurationService.get().global.fileNamePattern);

  constructor(private readonly _: SourceAuthoritesAfterAuthenticationService, private readonly configurationService: ConfigurationService) { }

  ngOnInit(): void {
  }
  configuration = this.configurationService.get();


}
